import React from "react";
import { Link } from "react-router-dom";
import { formatCurrency, siteConfig } from "../config/siteConfig";
import "../css/delivery.scss";

function Delivery() {
  return (
    <main id="main-content" className="delivery-page">
      <figure className="delivery-page__image">
        <img
          src="/img/delivery-pack.jpg"
          alt="Orders being carefully packed in a Hong Kong studio"
          width="1120"
          height="1400"
          decoding="async"
        />
        <figcaption>Carefully checked and packed in Hong Kong.</figcaption>
      </figure>

      <header className="delivery-page__header" aria-labelledby="delivery-title">
        <p className="delivery-page__eyebrow">Information</p>
        <h1 id="delivery-title">Shipping</h1>
        <p>
          Every order is checked and packed with care at our studio. We use
          tracked services wherever possible and will share dispatch details by email.
        </p>
      </header>

      <div className="delivery-page__body">
        <section aria-labelledby="delivery-dispatch">
          <p className="delivery-page__number" aria-hidden="true">
            01
          </p>
          <div>
            <h2 id="delivery-dispatch">Dispatch</h2>
            <p>{siteConfig.shipping.dispatch}.</p>
            <p>
              Made-to-order objects may take longer; the product page or order
              confirmation will show the expected lead time.
            </p>
          </div>
        </section>

        <section aria-labelledby="delivery-uk">
          <p className="delivery-page__number" aria-hidden="true">
            02
          </p>
          <div>
            <h2 id="delivery-uk">Delivery charge</h2>
            <p>
              Standard tracked delivery is {formatCurrency(siteConfig.shipping.standard)}
              for every order.
            </p>
            <p>Most parcels arrive within two to four working days after dispatch.</p>
          </div>
        </section>

        <section aria-labelledby="delivery-international">
          <p className="delivery-page__number" aria-hidden="true">
            03
          </p>
          <div>
            <h2 id="delivery-international">International delivery</h2>
            <p>
              Available destinations are shown at checkout. We do not accept orders
              to jurisdictions restricted by applicable sanctions or carrier rules.
            </p>
            <p>
              For a destination not listed, email{" "}
              <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.
            </p>
          </div>
        </section>

        <section aria-labelledby="delivery-problems">
          <p className="delivery-page__number" aria-hidden="true">
            05
          </p>
          <div>
            <h2 id="delivery-problems">Delays and damage</h2>
            <p>
              If tracking has not moved or a parcel arrives damaged, keep all
              packaging and <Link to="/contact">contact us</Link>. For sending an
              item back, read our <Link to="/returns">returns policy</Link>.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Delivery;
